import { notificationConstant } from '../constants';

export const notification = (state = {
    notification: null,
    fetching: false,
}, action) => {
    switch (action.type) {
        case notificationConstant.SHOW_LOADER: {
            return {
                ...state,
                fetching: true
            }
        }
        case notificationConstant.HIDE_LOADER: {
            return {
                ...state,
                fetching: false
            }
        }
        case "SUCCESS": {
            return {
                ...state,
                notification: {
                    type: "success",
                    message: action.payload
                },
                fetching: false
            }
        }
        case "FAILED": {
            return {
                ...state,
                notification: {
                    type: "failed",
                    message: action.payload
                },
                fetching: false
            }
        }
        case "RESET_NOTIFICATION": {
            return {
                ...state,
                notification: null
            }
        }
        default:
            return state
    }
}